import { createFileRoute } from "@tanstack/react-router"

import PermissionContentWrapper from "@/components/PermissionWrapper/PermissionContentWrapper"
import { PermissionActionType } from "@/constants/permissions"
import { uomLoader } from "@/screens/WarehouseReceiving/loaders"
import { IncomingGoodsReceiptDetailsLayout } from "@/screens/WarehouseReceiving/subfeatures/Incoming/components"

export const Route = createFileRoute("/app/warehouse-receiving/incoming/$goodsReceiptId/_layout")({
  loader: uomLoader,
  staleTime: Infinity,
  component: () => (
    <PermissionContentWrapper permissions={[PermissionActionType.WAREHOUSE_RECEIVING_VIEW]}>
      <IncomingGoodsReceiptDetailsLayout />
    </PermissionContentWrapper>
  ),
})
